import { Controller } from "stimulus"

// Minimizes the floating onboarding checklist to a progress pill and back. The choice is remembered
// per browser in localStorage under the panel's storage key (the alert_bar_controller.js approach),
// and storage that's unavailable (private mode, blocked) just means the panel always opens expanded.
//
// The root is server-rendered hidden and revealed here once the remembered state is applied.
export default class ChecklistPanelComponentController extends Controller {
  static targets = ["panel", "pill", "minimizeButton"]
  static values = { storageKey: String }

  connect() {
    this.apply(this.readMinimized())
    this.element.classList.remove("hidden")
  }

  minimize() {
    this.writeMinimized(true)
    this.apply(true)
    this.pillTarget.focus()
  }

  expand() {
    this.writeMinimized(false)
    this.apply(false)
    if (this.hasMinimizeButtonTarget) this.minimizeButtonTarget.focus()
  }

  apply(minimized) {
    this.panelTarget.classList.toggle("hidden", minimized)
    this.pillTarget.classList.toggle("hidden", !minimized)
  }

  get storageKey() {
    return `onboarding_panel_${this.storageKeyValue}_minimized`
  }

  readMinimized() {
    try {
      return window.localStorage.getItem(this.storageKey) === "true"
    } catch {
      return false
    }
  }

  writeMinimized(minimized) {
    try {
      if (minimized) {
        window.localStorage.setItem(this.storageKey, "true")
      } else {
        window.localStorage.removeItem(this.storageKey)
      }
    } catch {
      // Not remembered; the panel still minimizes for this page.
    }
  }
}
